module.exports = __webpack_public_path__ + "img/logo.ed5adb37.svg";